import * as React from "react";
import { SVGProps, memo } from "react";
const SvgDatasourceLiveIcon14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    role="img"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.99 3.422H11v7.464h-.004c-.101 1.178-1.964 2.117-4.246 2.117-2.282 0-4.145-.939-4.246-2.117H2.5V3.422h.01a1.236 1.236 0 0 1-.01-.153C2.5 2.016 4.403 1 6.75 1S11 2.016 11 3.269c0 .051-.003.103-.01.153ZM10 3.27c0 .078-.076.38-.716.722-.438.234-1.037.42-1.737.501a7.916 7.916 0 0 1-1.594 0c-.7-.082-1.299-.267-1.737-.5-.64-.343-.716-.645-.716-.723 0-.078.076-.38.716-.722C4.813 2.227 5.707 2 6.75 2c1.043 0 1.937.228 2.534.547.64.341.716.644.716.722ZM5.832 5.485a7.872 7.872 0 0 0 1.836 0c.848-.088 1.652-.299 2.332-.621V10.8c-.007.07-.11.368-.757.692-.6.3-1.477.511-2.493.511-1.016 0-1.893-.21-2.493-.51-.647-.325-.75-.622-.756-.693l-.001-.007v-5.93c.68.323 1.484.534 2.332.622Z"
      fill="#666"
    />
  </svg>
);
const Memo = memo(SvgDatasourceLiveIcon14Px);
export default Memo;
